/* Copyright (c) 2022 Xperi. All Rights Reserved. */

import type { TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import type { WhisperTypes } from '../../views/Whisper/WhisperTypes';
import { HIDE_WHISPER, SHOW_WHISPER } from './whisper.types';

export const showWhisperAction = (
    message?: string,
    iconType?: WhisperTypes,
): TivoPayloadAction<{ message?: string; iconType?: WhisperTypes }> => ({
    type: SHOW_WHISPER,
    payload: {
        message,
        iconType,
    },
});

export const hideWhisperAction = () => ({
    type: HIDE_WHISPER,
});
